import React, { useState } from "react";
import { Box, Drawer as MuiDrawer, AppBar as MuiAppBar, Toolbar, List, CssBaseline, IconButton, ListItemButton, ListItemIcon, ListItemText, Menu, MenuItem, Typography, Modal, Button, useMediaQuery, Divider, Tooltip } from '@mui/material';
import { styled, useTheme } from '@mui/material/styles';
import MenuOpenIcon from '@mui/icons-material/MenuOpen';
import { NavLink } from "react-router-dom";
import DashboardIcon from '@mui/icons-material/Dashboard';
import User from '../user';
import LogoutIcon from '@mui/icons-material/Logout';
import LyricsIcon from '@mui/icons-material/Lyrics';
import QueueMusicIcon from '@mui/icons-material/QueueMusic';
import MmsIcon from '@mui/icons-material/Mms';
import { Person } from "@mui/icons-material";
import LibraryMusicIcon from '@mui/icons-material/LibraryMusic';
import Collapse from '@mui/material/Collapse';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import SquareIcon from '@mui/icons-material/Square';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import CampaignIcon from '@mui/icons-material/Campaign';
import logoCreators from "../../img/logo2.png";
import logoGntunes from "../../img/logo4.svg";
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import RecommendIcon from '@mui/icons-material/Recommend';
import Groups2Icon from '@mui/icons-material/Groups2';
import { useSelector } from "react-redux";
import LibraryBooksIcon from '@mui/icons-material/LibraryBooks';
const drawerWidth = 260;
const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 500,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};
const AppBar = styled(MuiAppBar)(({ theme }) => ({
  zIndex: theme.zIndex.drawer + 1
}));

const DrawerHeader = styled("div")(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar
}));

const StyledList = styled(List)({
  // selected and (selected + hover) states
  '&& .Mui-selected, && .Mui-selected:hover': {
    backgroundColor: 'red',
    '&, & .MuiListItemIcon-root': {
      color: 'pink',
    },
  },
  // hover states
  '& .MuiSvgIcon-root': { color: '#FFFFFF' },
  '& .active .MuiListItemButton-root': {
    backgroundColor: '#fff',
    '& .MuiSvgIcon-root, &, & .MuiListItemIcon-root': { color: 'red' },
  },
  '& .MuiListItemButton-root': { color: '#fff' },
  '& .MuiListItemButton-root:hover': {
    backgroundColor: '#FFF',
    '&, & .MuiListItemIcon-root': {
      color: 'red',
    },
    '& .MuiSvgIcon-root': { color: 'red' },
  },
});
const hwset = { height: '20px', width: '20px' }

export default function Sidebar() {
  const [open, setOpen] = React.useState(false);
  const [openRoyalty, setOpenRoyalty] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [menuRowId, setMenuRowId] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null)
  const LogoApp = process.env.REACT_APP_APPURL == 'https://creator.groovenexus.com' ? logoCreators : logoGntunes
  const userData = useSelector((state) => state.userData.userData);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const navItems = [
    { id: 1, to: "/dashboard", text: "Dashboard", icon: <DashboardIcon sx={hwset} />, },
    { id: 2, to: "/mylinks", text: "My Links", icon: <LibraryMusicIcon sx={hwset} />, },
    {
      id: 3, to: "/importrevenue", text: "Song Hub", icon: <LyricsIcon sx={hwset} className="faIcons" />, hasCollapse: true,
      collapseItems: [{ id: 4, to: "/songhub", text: "Music", icon: <SquareIcon sx={hwset} style={{ transform: 'rotate(45deg)', height: '10px', width: '10px' }} />, },
      { id: 5, to: "/playlist", text: "Playlist", icon: <SquareIcon sx={hwset} style={{ transform: 'rotate(45deg)', height: '10px', width: '10px' }} />, },
      { id: 6, to: "/monetize-music", text: "Monetize Music", icon: <SquareIcon sx={hwset} style={{ transform: 'rotate(45deg)', height: '10px', width: '10px' }} />, },
      { id: 7, to: "/monetize-playlist", text: "Monetize Playlist", icon: <SquareIcon sx={hwset} style={{ transform: 'rotate(45deg)', height: '10px', width: '10px' }} />, },
      ]
    },
  ];
  if (userData?.beta) {
    navItems.splice(8, 0,
      { id: 9, to: "/campaign", text: "Campaign", icon: <CampaignIcon sx={hwset} /> },
    );
  }

  if (userData?.enable_distribution) {
    const additionalItems = [
      {
        id: 10,
        to: "/recommendations",
        text: "Recommendation",
        icon: <RecommendIcon sx={hwset} />,
      },
      {
        id: 11,
        to: "/importrevenue",
        text: "Collaborate",
        icon: <Groups2Icon sx={hwset} />,
        hasCollapse: true,
        collapseItems: [
          {
            id: 16,
            to: "/collaboration/categories",
            text: "Collaborate Now",
            icon: <SquareIcon sx={hwset} style={{ transform: "rotate(45deg)", height: "10px", width: "10px" }} />,
          },
          {
            id: 17,
            to: "/collab-request",
            text: "Collaboration Request",
            icon: <SquareIcon sx={hwset} style={{ transform: "rotate(45deg)", height: "10px", width: "10px" }} />,
          },
        ],
      },
      {
        id: 12,
        to: "/submitdemo",
        text: "Demo",
        icon: <QueueMusicIcon sx={hwset} />,
      },
      // { id: 13, to: "/associatedartist", text: "Associated Artist", icon: <Person sx={hwset} /> },
      {
        id: 14,
        to: "/studioassociatelist",
        text: "Studio Associate",
        icon: <Person sx={hwset} />,
      },
      {
        id: 15,
        to: "/Tools",
        text: "Tools",
        icon: <LibraryBooksIcon sx={hwset} />,
        hasCollapse: true,
        collapseItems: [
          {
            id: 16,
            to: "/course",
            text: "Course",
            icon: <SquareIcon sx={hwset} style={{ transform: "rotate(45deg)", height: "10px", width: "10px" }} />,
          },
          {
            id: 17,
            to: "/prompts",
            text: "Prompts",
            icon: <SquareIcon sx={hwset} style={{ transform: "rotate(45deg)", height: "10px", width: "10px" }} />,
          },
        ],
      },
      {
        id: 16,
        to: "/coverImage",
        text: "Cover Image",
        icon: <MmsIcon sx={hwset} />,
      },
    ].filter(Boolean); // filter out false entries

    navItems.splice(9, 0, ...additionalItems);
  }
  // Always add the Logout item at the end
  navItems.push({ id: 14, to: "/logout", text: "Logout", icon: <LogoutIcon sx={hwset} style={{ transform: 'rotate(180deg)' }} /> });

  const handleDrawerOpen = () => {
    handleClose()
    setOpen(!open);
  };

  function handleClickMenu(event, data) {
    setAnchorEl(event.currentTarget);
    setMenuRowId(data.id);
    if (data.text == "Song Hub") {
      handleClick()
    }
  }

  const handleClick = () => {
    setOpenRoyalty(!openRoyalty);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setMenuRowId(null);
  };

  const toggleDrawer = () => {
    setOpen((prev) => !prev);
    handleClose()
  };


  const handleNavItemClick = () => {
    if (isMobile) setOpen(false);
  };


  const handleNavigation = (e, path) => {
    handleClose()
    // if (!userData?.stage_name || !userData?.name
    //   || !userData?.userHandle || !userData?.gender
    //   || !userData?.languages?.length) {
    //   e.preventDefault();
    //   setOpenModal(true);
    // }
  };


  const listRender = (item) => {
    return (
      <ListItemButton className={`${open ? '' : 'pb-0'} rounded-3 `} onClick={(e) => handleClickMenu(e, item)} sx={{
        minHeight: 48,
        paddingTop: 0,
        marginTop: '10px !important',
        justifyContent: open ? 'initial' : 'center',
        flexDirection: open ? '' : 'column',
        alignItems: open ? '' : 'center',
        px: 2.5,
      }}>
        <Tooltip title={item.text} placement="right" arrow>
          <ListItemIcon sx={{
            minWidth: 0,
            mr: open ? 3 : '0px',
            justifyContent: 'center',
          }}>
            {item.icon}
            {(item?.hasCollapse && !open) ? <ChevronRightIcon sx={{
              position: 'absolute',
              right: '-7px',
              top: '14px',
              width: '20px',
              height: '20px'
            }} /> : null}
          </ListItemIcon>
        </Tooltip>
        {(isMobile || open) && <ListItemText primary={<Typography variant="span" sx={!open && {
          fontSize: '11px', display: item.text.length > 10 ? 'block' : 'inline-block',
          whiteSpace: item.text.length > 15 ? 'break-spaces' : 'nowrap',
          textAlign: 'center',
        }}>{item.text}</Typography>} />}
        {(item?.hasCollapse && open) ? (openRoyalty ? <ExpandLess /> : <ExpandMore />) : null}
      </ListItemButton >
    )
  }

  return (
    <Box sx={{ display: 'flex' }}>
      <CssBaseline />
      <AppBar className='bg-white shadow-none border' position="fixed" open={open}>
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            // onClick={handleDrawerOpen}
            onClick={toggleDrawer}
            className="text-black ms-1"
            edge="start"

          >
            <MenuOpenIcon />
          </IconButton>
          <Box sx={{
            marginLeft: 4,
          }}>
            <img src={LogoApp} className="w-100" />
          </Box>
          <Box className='d-flex align-items-center gap-5 w-100 justify-content-end' >
            <User />
          </Box>
        </Toolbar>
      </AppBar>
      <MuiDrawer
        variant={isMobile ? "temporary" : "permanent"}
        open={open}
        onClose={() => setOpen(false)}
        sx={{
          flexShrink: 0,
          width: isMobile ? drawerWidth : (open ? drawerWidth : 70),
          whiteSpace: "nowrap",
          transition: theme.transitions.create("width", {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen
          }),
          "& .MuiDrawer-paper": {
            width: isMobile ? drawerWidth : (open ? drawerWidth : 70),
            marginTop: isMobile ? 0 : '4rem',
            padding: "10px",
            boxSizing: "border-box",
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
            background: 'linear-gradient(180deg, #ED1C24 0%, #AA0066 100%)',
            boxShadow: '0px 4px 15px rgba(0, 0, 0, 0.55)',
            transition: theme.transitions.create("width", {
              easing: theme.transitions.easing.sharp,
              duration: theme.transitions.duration.enteringScreen
            })
          },
        }}
        ModalProps={{ keepMounted: true }}>
        {isMobile ? <DrawerHeader>
          <IconButton onClick={handleNavItemClick}>
            <ChevronLeftIcon fontSize="large" sx={{ color: "white" }} />
          </IconButton>
        </DrawerHeader> : null}
        <Divider sx={{ color: "white", display: isMobile ? 'block' : 'none' }} />
        <StyledList sx={{ padding: '0px' }}>
          <List sx={{ width: "100%", maxWidth: 360, paddingBottom: '5rem !important' }} className="p-0" component="nav" aria-labelledby="nested-list-subheader">
            {/* <StyledList sx={{ padding: '0px' }}> */}
            {navItems.map((item, index) => (
              <React.Fragment key={index}>
                {item?.hasCollapse ? (
                  <div>
                    {listRender(item)}
                    {isMobile ? null : <Menu
                      id={`basic-menu-${item.id}`}
                      anchorEl={anchorEl}
                      open={!open && menuRowId === item.id}
                      onClose={handleClose}
                      anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                      }}
                      MenuListProps={{
                        'aria-labelledby': `basic-button-${item.id}`,
                      }}
                    >
                      {item.collapseItems.map((option, i) => (
                        <MenuItem
                          key={i}
                          to={option.to}
                          className="p-0"
                          onClick={handleClose}
                        >
                          <NavLink onClick={handleNavigation} to={option.to} className="nav-list-items py-1 ">
                            {/* <ListItemText primary={option.text} /> */}
                            <ListItemButton className="tab-items rounded-3 ps-0" >
                              <ListItemIcon className="justify-content-center align-items-center" >
                                {option.icon}
                              </ListItemIcon>
                              <ListItemText primary={<Typography variant="span">{option.text}</Typography>} />
                            </ListItemButton>
                          </NavLink>
                        </MenuItem>
                      ))}
                    </Menu>}
                  </div>)
                  :
                  (<NavLink to={item.to} className='nav-list-items ' onClick={handleNavItemClick}>
                    {listRender(item)}
                  </NavLink>)
                }
                {(item?.hasCollapse && open) && (
                  <Collapse in={openRoyalty} timeout={300} unmountOnExit>
                    {item.collapseItems.map((collapseItem, collapseIndex) => (
                      <NavLink key={collapseIndex} to={collapseItem.to} className="nav-list-items" onClick={handleNavItemClick}>
                        <ListItemButton onClick={collapseItem.handleClick} className="tab-items my-2 rounded-3" >
                          <ListItemIcon className="p-2 justify-content-center align-items-center" >
                            {collapseItem.icon}
                          </ListItemIcon>
                          <ListItemText primary={collapseItem.text} />
                        </ListItemButton>
                      </NavLink>
                    ))}
                  </Collapse>
                )}

              </React.Fragment>
            ))}
          </List>
        </StyledList>

      </MuiDrawer>
      <Modal open={openModal}>
        <Box sx={style}>
          <Typography variant="h6">Please complete the General Details first!</Typography>
          <Typography variant="body1" mt={3}>To access all features, please complete your general details. Without this, functionalities will remain restricted.</Typography>
          <Box mt={3} textAlign={'end'} >
            <Button variant="contained" className="gn-actionbtn px-3 " onClick={() => setOpenModal(false)}>OK</Button>
          </Box>
        </Box>
      </Modal>
    </Box>
  );
}
